import { createSelector } from '@reduxjs/toolkit';
import {
  selectEmployerTypeProjects,
  selectSelectedProjectParent,
} from 'store/projects/selectors/projectsSelectors';
import { selectProjectsFromActiveEmployerThatUserHasResourceTo } from 'store/projects/selectors/userProjects.selectors';
import { selectUserActiveEmployerId } from 'store/user/selectors.js/user.selectors';

const selectBreadcrumbsState = (state) => state.breadcrumbs;

export const selectBreadcrumbs = createSelector(
  [selectBreadcrumbsState],
  (state) => state.path
);

export const selectProjectsCrumbRoute = createSelector(
  [
    selectSelectedProjectParent,
    selectProjectsFromActiveEmployerThatUserHasResourceTo,
    selectEmployerTypeProjects,
    selectUserActiveEmployerId,
  ],
  (parent, projects, employerProjects, activeEmployerId) => {
    let parentKey = [];
    if (parent.key) {
      // delete employer from parent projects key
      parentKey = parent.key.split('/');
      parentKey.splice(0, 2);
    }

    const projectPathKeys = [...parentKey];

    const projectPath = projectPathKeys.map((key) => {
      const project = projects.find((project) => project?.projectKey === key);
      return {
        key: project?.projectKey,
        name: `${project?.name} - ${project?.projectKey}`,
      };
    });

    const projectPathClean = projectPath.filter((item) => item.key); // Filter out items without a key

    const navigationActiveEmployer = employerProjects.find(
      (project) => project.id === activeEmployerId
    );

    const activeEmployerData = navigationActiveEmployer
      ? {
          key: navigationActiveEmployer.projectKey,
          name: navigationActiveEmployer.name,
        }
      : undefined;

    return {
      employers: [activeEmployerData],
      projectPath: projectPathClean,
    };
  }
);
